import { GalleryImage } from '../types';

export const galleryImages: GalleryImage[] = [
  {
    src: 'gallery/barnes1.jpg',
    alt: 'Painted interior wall and architectural detail',
    category: 'Painting',
  },
  {
    src: 'gallery/barnes2.jpg',
    alt: 'Interior architectural detail with painted finish',
    category: 'Details',
  },
  {
    src: 'gallery/barnes3.jpg',
    alt: 'Exterior surface with painted finish',
    category: 'Painting',
  },
  {
    src: 'gallery/gallery1.jpg',
    alt: 'Interior room with painted walls',
    category: 'Painting',
  },
  {
    src: 'gallery/inside.jpg',
    alt: 'Interior wall, trim, and material detail',
    category: 'Details',
  },
  {
    src: 'gallery/rekean1.jpg',
    alt: 'Painted residential interior',
    category: 'Painting',
  },
  {
    src: 'gallery/rekean2.jpg',
    alt: 'Painted architectural detail',
    category: 'Details',
  },
  {
    src: 'gallery/rekean3.jpg',
    alt: 'Connected interior rooms with painted finishes',
    category: 'Painting',
  },
  {
    src: 'services/Plaster/plaster-texture1.jpg',
    alt: 'Venetian plaster surface texture',
    category: 'Details',
  },
  {
    src: 'services/Wood Finishing/wood-detail1.jpg',
    alt: 'Stained wood surface showing grain detail',
    category: 'Details',
  },
];
